import { render, staticRenderFns } from "./modal-add-participant.vue?vue&type=template&id=ddc43e28&scoped=true"
import script from "./modal-add-participant.vue?vue&type=script&lang=js"
export * from "./modal-add-participant.vue?vue&type=script&lang=js"
import style0 from "./modal-add-participant.vue?vue&type=style&index=0&id=ddc43e28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc43e28",
  null
  
)

export default component.exports